import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  map,
  mergeMap,
  catchError,
  switchMap,
  concatMap
} from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import {
  entityLaboratoriosLoadRequest,
  entityLaboratoriosLoadFailure,
  entityLaboratoriosLoadSuccess,
  entityLaboratoriosAddFailure,
  entityLaboratoriosAddRequest,
  entityLaboratoriosAddSuccess,
  entityLaboratoriosDeleteRequest,
  entityLaboratoriosDeleteSuccess,
  entityLaboratoriosDeleteFailure
} from './laboratorios.actions';
import { LaboratoriosService } from './laboratorios.service';
import { entityTipoEquipamientoLaboratorioLoadRequest } from '../entity-tipos-equipamiento-laboratorio/tipos-equipamiento-laboratorio.actions';
import { NotificationService } from '../../../core/core.module';

@Injectable()
export class LaboratoriosEffects {
  // load
  loadRequestLaboratorios = createEffect(() =>
    this.actions$.pipe(
      ofType(entityLaboratoriosLoadRequest),
      mergeMap(() =>
        this.laboratoriosService.getLaboratorios().pipe(
          map((items) => entityLaboratoriosLoadSuccess({ items })),
          catchError((error) => of(entityLaboratoriosLoadFailure({ error })))
        )
      )
    )
  );

  addRequestLaboratorio = createEffect(() =>
    this.actions$.pipe(
      ofType(entityLaboratoriosAddRequest),
      switchMap((action) =>
        this.laboratoriosService.addLaboratorios(action.item).pipe(
          concatMap((item) => [entityLaboratoriosAddSuccess({ item })]),
          catchError((error) => of(entityLaboratoriosAddFailure({ error })))
        )
      )
    )
  );

  addSuccessLaboratorio = createEffect(() =>
    this.actions$.pipe(
      ofType(entityLaboratoriosAddSuccess),
      switchMap(() =>
        of(
          entityTipoEquipamientoLaboratorioLoadRequest(),
          entityLaboratoriosLoadRequest()
        )
      )
    )
  );

  deleteRequestLaboratorio = createEffect(() =>
    this.actions$.pipe(
      ofType(entityLaboratoriosDeleteRequest),
      mergeMap((action) =>
        this.laboratoriosService.deleteLaboratorio(action.item).pipe(
          map((item) => {
            this.alertService.success('Laboratorio eliminado correctamente.');
            return entityLaboratoriosDeleteSuccess({ item: action.item });
          }),
          catchError((error) => of(entityLaboratoriosDeleteFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private laboratoriosService: LaboratoriosService,
    private alertService: NotificationService
  ) {
    this.laboratoriosService.url = environment.apiUrl;
  }
}
